import { render } from "./AposSubformPreview.vue?vue&type=template&id=1909a802&scoped=true"
import script from "./AposSubformPreview.vue?vue&type=script&lang=js"
export * from "./AposSubformPreview.vue?vue&type=script&lang=js"

import "./AposSubformPreview.vue?vue&type=style&index=0&id=1909a802&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1909a802"],['__file',"ui/ui/apos/components/AposSubformPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1909a802"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1909a802', __exports__)) {
    api.reload('1909a802', __exports__)
  }
  
  module.hot.accept("./AposSubformPreview.vue?vue&type=template&id=1909a802&scoped=true", () => {
    api.rerender('1909a802', render)
  })

}


export default __exports__